'use client';
import React, { useId } from 'react';

export const RadialGauge = ({ max, min, value }) => {
  const gradientId = `radial-gauge-${useId().replace(/:/g, '')}`;
  const MULTIPLIER = 128.4911395318225;
  const gaugeFillStyle = {
    strokeDashoffset: value === 0 ? 130 : `${((max - value) / (max - min)) * MULTIPLIER}`,
  };

  const NumberCircle: React.FC<{ value: string; x: number; y: number }> = ({ value, x, y }) => {
    return (
      <g className="number-circle" fill="white" stroke="green" strokeWidth="0">
        <circle cx={x} cy={y} fill="#00000054" r="3"></circle>
        <text
          alignmentBaseline="middle"
          fill="#FFFFFF"
          fontSize="4px"
          fontWeight="600"
          textAnchor="middle"
          x={x}
          y={y + 0.25}
        >
          {value}
        </text>
      </g>
    );
  };

  return (
    <div className="container gauge-background">
      <div>
        <svg viewBox="0 0 100 55" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id={gradientId} x1="0%" x2="100%" y1="0%" y2="0%">
              <stop offset="0%" stopColor="#EF4444"></stop>
              <stop offset="25%" stopColor="#F97316"></stop>
              <stop offset="50%" stopColor="#FFD644"></stop>
              <stop offset="75%" stopColor="#84CC16"></stop>
              <stop offset="100%" stopColor="#30BF60"></stop>
            </linearGradient>
          </defs>
          <path
            d="M10,50 A40,40 0 1,1 90,50"
            fill="none"
            stroke="#E1EAF9"
            strokeDasharray="0"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeWidth="8"
          ></path>
          <path
            d="M10,50 A40,40 0 1,1 90,50"
            fill="none"
            stroke={`url(#${gradientId})`}
            strokeDasharray="128.4911395318225"
            strokeLinecap="round"
            strokeWidth="8"
            style={gaugeFillStyle}
          ></path>
          <NumberCircle value="1" x={10} y={50} />
          <NumberCircle value="2" x={20.25} y={23} />
          <NumberCircle value="3" x={50} y={10} />
          <NumberCircle value="4" x={80} y={23} />
          <NumberCircle value="5" x={90} y={50} />
        </svg>
      </div>
    </div>
  );
};

export default RadialGauge;
